import apiClient from '../../services/apiClient';
import { downloadCsv } from '../../lib/downloadBlob';
import type {
  Answers,
  SurveyInstrumentFull,
  SurveyInstrumentPublic,
  SurveyInstrumentSummary,
  SurveyReport,
  CompletionRow,
  Question,
} from './types';

// Student -------------------------------------------------------------------

export async function listOpenSurveys(): Promise<SurveyInstrumentSummary[]> {
  const { data } = await apiClient.get<{ instruments: SurveyInstrumentSummary[] }>('/api/v1/surveys');
  return data.instruments;
}

export async function getSurvey(key: string): Promise<{ instrument: SurveyInstrumentPublic; completed: boolean }> {
  const { data } = await apiClient.get(`/api/v1/surveys/${key}`);
  return data;
}

export async function submitSurveyResponse(key: string, answers: Answers): Promise<void> {
  await apiClient.post(`/api/v1/surveys/${key}/responses`, { answers });
}

// Instructor ------------------------------------------------------------------

export async function listAllInstruments(): Promise<SurveyInstrumentFull[]> {
  const { data } = await apiClient.get<{ instruments: SurveyInstrumentFull[] }>('/api/v1/surveys/instruments');
  return data.instruments;
}

export interface InstrumentPatch {
  title?: string;
  description?: string | null;
  questions?: Question[];
  opens_session_id?: string | null;
  closes_session_id?: string | null;
  closes_after_days?: number;
  is_open?: boolean | null;
}

export async function updateInstrument(key: string, patch: InstrumentPatch): Promise<SurveyInstrumentFull> {
  const { data } = await apiClient.put(`/api/v1/surveys/instruments/${key}`, patch);
  return data.instrument;
}

export async function seedDefaultInstruments(): Promise<{ created: number; updated: number; warnings: string[] }> {
  const { data } = await apiClient.post('/api/v1/surveys/seed-defaults');
  return { warnings: [], ...data };
}

export async function getSurveyReport(key: string): Promise<SurveyReport> {
  const { data } = await apiClient.get(`/api/v1/surveys/${key}/report`);
  return data;
}

export async function getSurveyCompletions(key: string): Promise<CompletionRow[]> {
  const { data } = await apiClient.get<{ completions: CompletionRow[] }>(`/api/v1/surveys/${key}/completions`);
  return data.completions;
}

export async function downloadSurveyReportCsv(key: string): Promise<void> {
  await downloadCsv(`/api/v1/surveys/${key}/report.csv`, `survey-${key}.csv`);
}
